import React, { Component } from "react";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/RemoveCircleOutline";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import GoogleMapsComponent from "./GoogleMaps";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import api from "../api";
import Checkbox from "@material-ui/core/Checkbox";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import SearchIcon from "@material-ui/icons/Search";
import Popover from "@material-ui/core/Popover";
import ViewIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

require("dotenv").config();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  menu_item: {
    fontSize: "0.7rem"
  },
  tableCell: {
    padding: "0px",
    border: "1px solid #dee2e6"
  }
});

class Providers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loading: true,
      popover: { popover: -1, anchorEl: "", open: false },
      budgets: [],
      contact_location: { lat: "", lng: "" },
      providers: {
        filter: {
          is_official: 0,
          best_score: 0,
          most_near: 0,
          has_valet: 0,
          has_crane: 0,
          business_name: "",
          provider_type_id: "",
          code: ""
        },
        provider_types: [],
        providers: [],
        providers_selected: []
      },
      snackbar: { open: false, severity: "" }
    };
    this.handleAddProvider = this.handleAddProvider.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount() {
    await this.getBudgets(this.props.work_order.id);
    var provider_types = await this.getProviderTypes();
    var providers = this.state.providers;
    providers.provider_types = provider_types;
    var contact_location = this.props.contact_location;

    if (this.props.work_order.official_provider_required) {
      providers.filter.is_official = this.props.work_order.official_provider_required;
    }
    if (this.props.work_order.default_provider_type_id) {
      providers.filter.provider_type_id = this.props.work_order.default_provider_type_id;
    }
    this.setState({
      providers: providers,
      contact_location: contact_location,
      loading: false
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ contact_location: nextProps.contact_location });
  }

  getBudgets(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.work_order().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ budgets: res.data.budgets });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getProviderTypes() {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.provider_types, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        return response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  handleChange = e => {
    var value = e.target.value;
    var name = e.target.name;
    var providers = this.state.providers;
    if (
      name === "most_near" ||
      name === "is_official" ||
      name === "best_score" ||
      name === "has_valet" ||
      name === "has_rebate" ||
      name === "has_crane"
    ) {
      providers.filter[name] = e.target.checked;
    } else if (name.includes("checked")) {
      var element = e.target.name.split(".");
      var key = element[0];
      var id = element[1];
      providers.providers[id][key] = e.target.checked;
    } else {
      providers.filter[name] = value;
    }
    this.setState({ providers: providers });
  };

  handleSelectProvider = (e, provider_idx, address_idx) => {
    var providers = this.state.providers;
    providers.providers[provider_idx]["checked"] = e.target.checked;
    providers.providers[provider_idx]["address_id"] = "";
    if (address_idx !== "") {
      providers.providers[provider_idx]["address_id"] =
        providers.providers[provider_idx].contact.address[address_idx].id;
    }
    this.setState({ providers: providers });
  };

  handleSearch = () => {
    var lat = -34.515376;
    var long = -58.474357;
    var contact_location = this.state.contact_location;
    lat =
      contact_location.lat !== null && contact_location.lat !== ""
        ? contact_location.lat
        : lat;
    long =
      contact_location.lng !== null && contact_location.lng !== ""
        ? contact_location.lng
        : long;
    var filter = this.state.providers.filter;
    const token = localStorage.getItem("userToken");
    filter.most_near =
      filter.most_near !== true && filter.most_near !== 1 ? 0 : 1;
    filter.best_score =
      filter.best_score !== true && filter.best_score !== 1 ? 0 : 1;
    filter.is_official =
      filter.is_official !== true && filter.is_official !== 1 ? 0 : 1;
    filter.has_crane =
      filter.has_crane !== true && filter.has_crane !== 1 ? 0 : 1;
    filter.has_valet =
      filter.has_valet !== true && filter.has_valet !== 1 ? 0 : 1;
    filter.has_rebate =
      filter.has_rebate !== true && filter.has_rebate !== 1 ? 0 : 1;
    axios
      .get(
        api
          .providers()
          .latlng(
            long,
            lat,
            filter.business_name,
            filter.is_official,
            filter.provider_type_id,
            filter.best_score,
            filter.most_near,
            this.props.plate,
            filter.has_crane,
            filter.has_valet,
            filter.has_rebate,
            filter.code
          ),
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(response => {
        var providers = this.state.providers;
        providers.providers = response.data;
        this.setState({ providers: providers });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleAddProvider() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
    this.getBudgets(this.props.work_order.id);
  }

  handleMapChange = providers_search => {
    var providers = this.state.providers;
    providers.providers = providers_search;
    this.setState({ providers: providers });
  };

  handlePopOver = (e, idx) => {
    var popover = this.state.popover;
    popover.open = true;
    popover.anchorEl = e.currentTarget;
    popover.popover = idx;
    this.setState({ popover: popover });
  };

  handleSnackbar = e => {
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };

  handleSubmit = () => {
    this.state.providers.providers.map((val, idx) => {
      if (val.checked === true) {
        var formData = new FormData();
        formData.set("budget[version]", "1.0");
        formData.set("budget[work_order_id]", this.props.work_order.id);
        formData.set("budget[budget_type_id]", "1");
        formData.set("budget[budget_state_id]", "1");
        formData.set("budget[provider_id]", val.id);
        formData.set("budget[address_id]", val.address_id);
        let self = this;
        const token = localStorage.getItem("userToken");
        axios
          .post(api.budgets().post(), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            var snackbar = {
              open: true,
              success_message: "Proveedor cargado con éxito",
              severity: "success"
            };
            this.setState({ snackbar: snackbar });
            this.handleClose();
            this.props.onUpdateWorkOrderState();
          })
          .catch(function(error) {
            var error_message = "";
            var errors = error.response.data;
            if (errors.errors) {
              if (errors.errors.status_code !== 404) {
                var keys = Object.keys(errors.errors);
                for (var i = 0; i < keys.length; i++) {
                  var key = keys[i];
                  var key_errors = errors.errors[key];
                  key_errors.map((val, idx) => {
                    error_message = error_message.concat(val).concat(" ");
                  });
                }
              } else {
                error_message =
                  "Ha ocurrido un error. Contacte a su administrador";
              }
            } else {
              error_message =
                "Ha ocurrido un error. Contacte a su administrador";
            }

            var snackbar = {
              open: true,
              success_message: error_message,
              severity: "warning"
            };
            self.setState({ snackbar: snackbar });
            console.log(error);
          });
      }
    });
  };

  handleRemoveBudget = async (e, id) => {
    var budgets = this.state.budgets;
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .delete(api.budgets().delete(id), {
        headers: { Authorization: `Bearer ${token}` },
        params: { id: id }
      })
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Proveedor elimimado con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
        this.getBudgets(this.props.work_order.id);
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }
        } else {
          error_message = "Ha ocurrido un error. Contacte a su administrador";
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
        console.log(error);
      });
  };

  render() {
    const classes = this.props.classes;
    const days = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miércoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sabado"
    };
    var provider_types = this.state.providers.provider_types;
    var filter = this.state.providers.filter;

    var desired_zone = this.props.mobile_data
      ? this.props.mobile_data.desired_zone
        ? JSON.parse(this.props.mobile_data.desired_zone).details.geometry
            .location
        : {}
      : {};
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={5000}
          onClose={this.handleSnackbar}
        >
          <Alert
            onClose={this.handleSnackbar}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={this.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Proveedores
              </Typography>
            </Toolbar>
          </AppBar>
          <div className="row mt-2 mx-0">
            <div className="col col-md-4">
              <GoogleMapsComponent
                height="300px"
                places={[]}
                disabled={false}
                providers={this.state.providers.providers}
                contact_location={this.state.contact_location}
                desired_zone={desired_zone}
                plate={this.props.plate}
                onChange={this.handleMapChange}
              />
            </div>
            <div className="col col-md-8">
              <div className="row">
                <TextField
                  id="business_name"
                  name="business_name"
                  value={filter.business_name}
                  onChange={this.handleChange}
                  placeholder="Buscar por nombre"
                  margin="normal"
                  className="mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 70 }}>
                          Proveedor
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 130, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="code"
                  name="code"
                  value={filter.code}
                  onChange={this.handleChange}
                  placeholder="Buscar por código"
                  margin="normal"
                  className="mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 70 }}>
                          Cód. Hansa
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { maxWidth: 100, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="provider_type_id"
                  name="provider_type_id"
                  value={filter.provider_type_id}
                  onChange={this.handleChange}
                  select
                  margin="normal"
                  className="mt-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    style: { minWidth: 70, fontSize: "0.75rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 125 }}>
                          Tipo de proveedor
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                >
                  <MenuItem
                    key={"todos"}
                    value={""}
                    className={classes.menu_item}
                  >
                    Todos
                  </MenuItem>
                  {provider_types.map(option => (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                      className={classes.menu_item}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="row mb-2">
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="is_official"
                      name="is_official"
                      value={filter.is_official}
                      checked={filter.is_official}
                      onChange={this.handleChange}
                    />
                  }
                  label={<Typography variant="caption">Es oficial</Typography>}
                  labelPlacement="top"
                />
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="has_rebate"
                      name="has_rebate"
                      value={filter.has_rebate}
                      onChange={this.handleChange}
                    />
                  }
                  label={
                    <Typography variant="caption">Tiene rebate</Typography>
                  }
                  labelPlacement="top"
                />
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="best_score"
                      name="best_score"
                      value={filter.best_score}
                      onChange={this.handleChange}
                    />
                  }
                  label={
                    <Typography variant="caption">Mejor puntuación</Typography>
                  }
                  labelPlacement="top"
                />
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="most_near"
                      name="most_near"
                      value={filter.most_near}
                      onChange={this.handleChange}
                    />
                  }
                  label={<Typography variant="caption">Mas cercano</Typography>}
                  labelPlacement="top"
                />
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="has_valet"
                      name="has_valet"
                      value={filter.has_valet}
                      onChange={this.handleChange}
                    />
                  }
                  label={
                    <Typography variant="caption">Ofrece valet</Typography>
                  }
                  labelPlacement="top"
                />
                <FormControlLabel
                  className="mt-1 mx-2"
                  control={
                    <Switch
                      size="small"
                      id="has_crane"
                      name="has_crane"
                      value={filter.most_near}
                      onChange={this.handleChange}
                    />
                  }
                  label={<Typography variant="caption">Ofrece grua</Typography>}
                  labelPlacement="top"
                />
                <Button
                  className="my-auto ml-3"
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ fontSize: "0.75rem", height: "fitContent" }}
                  onClick={this.handleSearch}
                  endIcon={<SearchIcon />}
                >
                  Buscar
                </Button>
              </div>
              <div
                className="row"
                style={{
                  height: "400px",
                  maxHeight: "400px",
                  overflow: "scroll"
                }}
              >
                <Table
                  size="small"
                  aria-label="a dense table"
                  style={{ width: "auto" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        &nbsp;
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                        colSpan="2"
                      >
                        Provedor
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        Tipo
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        Oficial?
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        Rebate
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          fontWeight: "550",
                          padding: "4px",
                          minWidth: "70px"
                        }}
                      >
                        Cta cte?
                      </TableCell>

                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        Telefono
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550", padding: "4px" }}
                      >
                        Dirección
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.providers.providers.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6}>SIN RESULTADOS</TableCell>
                      </TableRow>
                    ) : (
                      ""
                    )}
                    {this.state.providers.providers.map((val, idx) => {
                      if (!val.contact.address) {
                        val.contact.address = [];
                      }
                      return val.contact.address.length > 0 ? (
                        val.contact.address.map((val2, idx2) => {
                          return (
                            <TableRow
                              style={{
                                verticalAlign: "top",
                                overflowX: "scroll"
                              }}
                            >
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontWeight: "550", padding: "4px" }}
                              >
                                <Checkbox
                                  id={"checked." + idx}
                                  name={"checked." + idx}
                                  data-addressid={idx2}
                                  onChange={e => {
                                    this.handleSelectProvider(e, idx, idx2);
                                  }}
                                  color="primary"
                                  checked={val.checked}
                                  style={{ height: 0, width: 0 }}
                                />
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                <a
                                  href={"/provider/" + val.id + "/1"}
                                  target="_blank"
                                >
                                  {val.business_name}
                                </a>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                <a
                                  href={"/provider/" + val.id + "/1"}
                                  target="_blank"
                                >
                                  {val.fantasy_name}
                                </a>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val.types.length > 0
                                  ? val.types[0].type.name
                                  : ""}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val.is_official ? "Si" : "No"}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val.rebate ? val.rebate + "%" : "No"}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val.has_deposit_account ? "Si" : "No"}
                              </TableCell>

                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val.contact.phone}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                style={{ fontSize: "0.75rem", padding: "4px" }}
                              >
                                {val2.data
                                  ? JSON.parse(val2.data).formatted_address +
                                    " - " +
                                    Math.round(val2.distance) +
                                    "km"
                                  : ""}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <React.Fragment>
                          <TableRow style={{ verticalAlign: "top" }}>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontWeight: "550", padding: "4px" }}
                            >
                              <Checkbox
                                id={"checked." + idx}
                                name={"checked." + idx}
                                data-addressid={""}
                                onChange={e => {
                                  this.handleSelectProvider(e, idx, "");
                                }}
                                color="primary"
                                checked={val.checked}
                                style={{ height: 0, width: 0 }}
                              />
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              <a
                                href={"/provider/" + val.id + "/1"}
                                target="_blank"
                              >
                                {val.business_name}
                              </a>
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              <a
                                href={"/provider/" + val.id + "/1"}
                                target="_blank"
                              >
                                {val.fantasy_name}
                              </a>
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.types.length > 0
                                ? val.types[0].type.name
                                : ""}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.is_official ? "Si" : "No"}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.rebate ? val.rebate + "%" : "No"}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.has_deposit_account ? "Si" : "No"}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.contact.phone}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem", padding: "4px" }}
                            >
                              {val.contact.address.length > 0
                                ? val.contact.address[0].data
                                  ? JSON.parse(val.contact.address[0].data)
                                      .formatted_address +
                                    " - " +
                                    Math.round(
                                      val.contact.address[0].distance
                                    ) +
                                    "km"
                                  : ""
                                : ""}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
              <div class="row">
                <Button
                  className="mt-2 ml-0"
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={this.handleSubmit}
                >
                  Preseleccionar
                </Button>
              </div>
            </div>
          </div>
        </Dialog>

        <Row>
          <Col>
            <Table
              size="small"
              aria-label="a dense table"
              style={{ width: "auto", marginTop: "8px" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Provedor
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    CUIT
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Telefono
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Dirección
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Tipo
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Desc. en factura
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Contacto
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    Horarios
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                    &nbsp;
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.budgets.map((val, idx) => {
                  return (
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        <a
                          target="_blank"
                          href={"/provider/" + val.provider.id + "/0"}
                        >
                          {val.provider.business_name}
                        </a>
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.document_number}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.phone}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.email}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.address
                          ? JSON.parse(val.provider.address).formatted_address
                          : ""}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.type}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.discount_in_vouchers ? "Si" : "No"}{" "}
                        {val.provider.discount
                          ? ": %" + val.provider.discount
                          : ""}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        <ViewIcon
                          fontSize="small"
                          onClick={() =>
                            window.open("/subcontacts/" + val.provider.contact)
                          }
                        />
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {val.provider.schedules.length > 0 ? (
                          <ViewIcon
                            fontSize="small"
                            onMouseOver={e => {
                              this.handlePopOver(e, idx);
                            }}
                            onMouseOut={e => {
                              this.handlePopOver(e, idx);
                            }}
                          />
                        ) : (
                          <VisibilityOffIcon fontSize="small" />
                        )}
                        <Popover
                          id={idx}
                          open={
                            this.state.popover.open &&
                            idx === this.state.popover.popover
                          }
                          anchorEl={this.state.popover.anchorEl}
                          onMouseOut={e => {
                            this.handlePopOver(e);
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center"
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center"
                          }}
                        >
                          <div className="p-3">
                            {val.provider.schedules.map((schedule, idx2) => {
                              return (
                                <Row>
                                  <Col>
                                    {days[schedule.day]}: {schedule.hour_from} -{" "}
                                    {schedule.hour_to}
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </Popover>
                      </TableCell>
                      <TableCell>
                        <DeleteIcon
                          onClick={e => this.handleRemoveBudget(e, val.id)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {!this.state.loading ? (
              <Button
                disabled={
                  this.props.work_order.state === "cerrada" ? true : false
                }
                className="mt-3"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={this.handleAddProvider}
              >
                Agregar Proveedores
              </Button>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Providers);
